import React, { useEffect, useState} from 'react';

import { Fragment } from 'react';
import { useHistory } from 'react-router-dom';

const Product = (props) => {
    const [showModal, setShowModal] = useState(false);
    const history = useHistory(); 
    
    const openModal = (itemId) =>{
        props.showModal(itemId);
    }
 
    useEffect(() => {
        const _ids = process.env.CustIdMoreInfoModal.split(",");
        setShowModal(_ids.indexOf(props.pCustId)>=0);
    },[props.pCustId]);

    useEffect(() => {
        PriceAndStockHandler(props.custItem);
    },[props.custItem]);
    
    const AddToCartHandler = (e, itemId) => {
        e.preventDefault();
        
        if (window?.customEmbedOverrides?.AddToCartHandler) {
            window.customEmbedOverrides.AddToCartHandler(e, itemId);
          } else {
            // Default logic
            console.log("Default Add to Cart", itemId);

            let _url = '/sku/' + itemId
            
            history.push(_url);
          }
    } 

    const PriceAndStockHandler = (itemId) => {
        if (window?.customEmbedOverrides?.InjectStockAndPrice) {
            window.customEmbedOverrides.InjectStockAndPrice(itemId);
          }
    } 

    const displayButtons = (itemId) =>
    {
            return <div className="d-flex gap-2">
                {  showModal && props.pCustId=="711442" && (
                
                    <a href="https://www.sierraparts.com/en-us/find-a-dealer" 
                        className="btn btn-sm btn-success rounded-pill border w-auto text-nowrap">Dealer Locator</a>
                
                )}
                
                    <a onClick={() =>  openModal(props.productId)} 
                        className="btn btn-sm btn-light rounded-pill border w-auto text-nowrap">Read More</a>
                
                { props.custItem && (
                    //props.searchType == 'simple' &&
                    <a data-cartbutton={itemId} onClick={(e) => AddToCartHandler(e, props.custItem)} 
                        className="btn btn-sm btn-primary rounded-pill w-auto text-nowrap">Add to Cart</a>
                
                )}
            </div>
    }

    return (
        <div className="result-item" key={props.passedKey}>
            <div className="row">
                <div className="result-image">
                    <figure>
                        {props.imagePath ? <img src={process.env.IMAGE_PATH + "/tr:w-70/" + props.imagePath} alt={props.description} /> : null}
                    </figure>
                </div>
                <div className="result-id">
                    <span className="saleItem" title={props.custItem ? props.custItem : props.saleItem}>{props.saleItem}</span>
                </div>
                <div className="result-description">
                    <h4>{props.description}</h4>
                    <span>{props.categoryParent}</span> / <span>{props.categoryChild}</span>
                    {props.oeNumber ? <Fragment><br /><span>OEM part: {props.oeNumber}</span></Fragment> : null}

                </div>
                <div className="result-link">
                    <div className="d-flex flex-column justify-content-center align-items-end">
                        <div className="d-flex gap-2 align-items-center justify-content-between">
                            <div className="stock-message fw-light">
                                <div data-sku={props.custItem} className="product-price fw-bold text-muted">{props.listPrice}</div>
                                <div data-inv={props.custItem}></div>
                            </div>
                            <div className="button-group d-flex gap-1">
                                {displayButtons(props.custItem)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



export default Product;